import { TextIcon } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const STextIcon = styled(TextIcon)``;
